import { useMediaQuery } from "react-responsive";
import { ReactComponent as TelegramDesktop } from "../../assets/social-icons/Telegram-desktop.svg";
import { ReactComponent as TwitterDesktop } from "../../assets/social-icons/Twitter-desktop.svg";
import { ReactComponent as DiscordDesktop } from "../../assets/social-icons/discord-desktop.svg";

import { LAUNCH_APP, socialLink } from "../../config/external-links";
import HoveredStateIcon from "../HoveredStateIcon";
import { MotionInView } from "../MotionInView";
import { varFadeInUp } from "../variants";

const footerLinks = {
  About: [
    {
      label: "Docs",
      href: "https://docs.rfx.exchange/",
    },
    {
      label: "Terms of Use",
      href: "https://app.rfx.exchange/terms-of-use",
    },
  ],

  Support: [
    {
      label: "Discord",
      href: "https://discord.com/invite/4b8RGrdzBx",
    },
    {
      label: "Status",
      href: "#",
    },
  ],
};

const NewSlide7 = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <section className="h-screen snap-start  !font-sans relative pt-[120px]  xl:pt-0 xl:pb-0 min-h-screen xl:h-screen overflow-hidden w-full">
      <div className="relative h-full w-full flex flex-col items-center justify-end">
        <div
          className={`flex-1 flex flex-col gap-12 scale-90 justify-center ${
            isMobile && "items-center w-full px-6 flex flex-col"
          }`}
        >
          <MotionInView className="w-[320px]" variants={varFadeInUp}>
            <a
              className="w-full block"
              href={LAUNCH_APP}
              target="_blank"
              rel="noreferrer"
            >
              <button className="p-3 transition-all duration-150 hover:bg-main w-full text-base font-semibold text-white rounded-sm bg-hype-darker">
                WITHDRAW LIQUIDITY FROM BETA
              </button>
            </a>
          </MotionInView>
          <MotionInView variants={varFadeInUp}>
            <div
              className={`flex flex-col gap-8 w-[320px] items-center justify-center`}
            >
              <img
                alt="logo"
                src="/icons/rfx-logo.svg"
                width={320}
                height={120}
              />
            </div>
          </MotionInView>

          <MotionInView
            variants={varFadeInUp}
            className="w-full flex justify-center"
          >
            <div className="mt-[25px] flex justify-between items-center w-[320px]">
              <a
                target="_blank"
                rel="noreferrer"
                href={socialLink.DISCORD_URL}
                className="hover:[&_svg_path]:fill-[#5865f2] duration-200"
              >
                <DiscordDesktop />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={socialLink.TWITTER_URL}
                className="hover:[&_svg_path]:fill-white duration-200"
              >
                <TwitterDesktop />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={socialLink.TELEGRAM_URL}
                className="hover:[&_svg_path]:fill-[#08c] duration-200"
              >
                <TelegramDesktop />
              </a>
              <a target="_blank" rel="noreferrer" href={socialLink.MIRROR_URL}>
                <HoveredStateIcon
                  icon={
                    <img
                      alt=""
                      className="w-[24px] h-[24px]"
                      src="/icons/mirror.svg"
                    />
                  }
                  hoverIcon={
                    <img
                      alt=""
                      className="w-[24px] h-[24px]"
                      src="/icons/mirror-colored.svg"
                    />
                  }
                />
              </a>
            </div>
          </MotionInView>
        </div>

        <div className="px-6 sm:px-0 w-full border-0 pb-[48px] min-h-[257px] pt-6 xl:border-t border-border-primary flex items-start text-left justify-between">
          <div></div>
          <div className="flex flex-col gap-4">
            <FooterHeading label="About" />
            <FooterLinks links={footerLinks["About"]} />
          </div>

          <div className="flex flex-col gap-4">
            <FooterHeading label="Support" />
            <FooterLinks links={footerLinks["Support"]} />
          </div>
          <div></div>
        </div>
      </div>
    </section>
  );
};

const FooterHeading = ({ label }) => {
  return (
    <div className="text-base font-noto-sans-thai font-semibold text-greyscale-text-primary leading-6">
      {label}
    </div>
  );
};

const FooterLinks = ({ links }) => {
  return (
    <div className="flex flex-col gap-3">
      {links.map((link) => (
        <a
          key={link.label}
          href={link.href}
          className="text-greyscale-text-secondary text-sm font-medium font-noto-sans-thai hover:text-greyscale-text-primary"
        >
          {link.label}
        </a>
      ))}
    </div>
  );
};

export default NewSlide7;
